import { forwardRef, type HTMLAttributes } from 'react';
import ResourceTileIcon from '@assets/img/dice-game/resource.svg?react';
import cn from 'classnames';

import { Tile } from '../Tile/Tile';
import { TilesBg } from '../TilesBg/TilesBg';

interface ResourceTileProps extends HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
}

const ResourceTile = forwardRef<HTMLDivElement, ResourceTileProps>(
  (props, ref) => {
    return (
      <Tile
        ref={ref}
        {...props}
        variant={props.isActive ? 'dark' : 'grey'}
        className={cn(props.className, 'flex items-center justify-center')}
      >
        <ResourceTileIcon className="size-[90%] relative z-[3]" />

        {props.isActive && <TilesBg variant="green-active" />}
      </Tile>
    );
  },
);

export { ResourceTile };
